import { createReducer, createActionHandler } from '@pressreader/appstore';

import { AnyPopup } from '../types';

import { contextMenuCloseDone, dialogCloseDone, openContextMenuAction, openDialogAction } from './actions';

interface IState {
    popups: AnyPopup[];
}

const initialState: IState = {
    popups: [],
};

const reducer = createReducer(
    initialState,
    createActionHandler(openContextMenuAction, (state, { payload }) => ({ ...state, popups: [...state.popups, payload.menu] })),
    createActionHandler(contextMenuCloseDone, (state, { payload }) => ({ ...state, popups: state.popups.filter(({ id }) => id !== payload.id) })),
    createActionHandler(openDialogAction, (state, { payload }) => ({ ...state, popups: [...state.popups, payload.dialog] })),
    createActionHandler(dialogCloseDone, (state, { payload }) => ({ ...state, popups: state.popups.filter(({ id }) => id !== payload.id) })),
);

export { IState, reducer };
